import { Component } from '@angular/core';
import { RoleConstants } from '@app/@shared/constants/role.constant';
import { AuthenticationService } from '@app/services/authentication.service';
import { BreadcrumbElement, ToolsService } from '@app/services/tools.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  pageName: string;
  subBreadcrumbs: BreadcrumbElement[] = [];
  isLoggedIn: Boolean = false;
  menuVisible: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private tools: ToolsService,
    public constants: RoleConstants
  ) {
    this.authenticationService.isLoggedIn.subscribe((value) => {
      this.isLoggedIn = value;
    });

    this.tools.pageName.subscribe((value) => (this.pageName = value));
    this.tools.menuVisible.subscribe((value) => (this.menuVisible = value));
    this.tools.subNavigation.subscribe((elements) => (this.subBreadcrumbs = elements));
  }
}
